<template>
  <div>
  <b-row>
    <b-col cols="12" sm="2"  class="mb-1">
      <b-form-group class="mb-0"  label="Per page">
        
        <b-form-select
          id="perPageSelect"
          v-model="perPage"
          :options="
            pageOptions.map((option) => ({ text: option, value: option }))
          "
          size="sm"
      
        />
      </b-form-group>
    </b-col>

    <b-col cols="12" sm="3" class="mb-1">
      <b-form-group
        label="Filter"
      
        class="mb-0"
      >
        <b-input-group size="sm">
          <b-form-input
            id="filterInput"
            v-model="searchQuery"
            type="search"
            placeholder="Type to Search"
          />
          <b-input-group-append>
            <b-button :disabled="!searchQuery" @click="searchQuery = ''">
              Clear
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>


  </b-row>
  <b-row>

   
    
    <b-col cols="12">
      
      <b-row>
        <b-col cols="12" sm="4">
          <b-form-group label="Campaign Name" label-for="campaignNameSelect">
            <b-form-select
              id="campaignNameSelect"
              v-model="selectedCampaignName"
              @change="filterTable()"
              :options="campaigns"
            >
              <option value="All">All</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12"sm="4">
          <b-form-group label="Status" label-for="statusSelect">
            <b-form-select
              id="statusSelect"
              v-model="selectedStatus"
              @change="filterTable()"
              :options="statuses"
            >
              <option value="All">All</option>
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col cols="12"sm="4" class="d-flex align-items-center">
          <b-button @click="clearFilters"> Clear </b-button>
        </b-col>
        <b-col cols="12" class="d-flex justify-content-end my-1">
      <b-button
        variant="primary"
        :to="{
          path: '/email/add',
        }"
      >
        Add Email Campaign
      </b-button>
    </b-col>
      </b-row>
    </b-col>
    
    <b-col cols="12">
      <b-table
        striped
        hover
        responsive
        :items="tableItems"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        v-if="!loading"
      >
        <template #cell(id)="data">
          {{ data.item.id }}
        </template>
        <template #cell(status)="data">
          <b-badge :variant="getStatusVariant(data.item.status)">{{
            data.item.status
          }}</b-badge>
        </template>
        <template #cell(createdOn)="data">
    {{ formatDate(data.item.createdOn) }}
  </template>
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="text-body align-middle mr-25"
              />
            </template>
            <b-dropdown-item
              v-if="
                [
                  'DRAFT',
                  'SCHEDULED',
                  'CANCELLED',
                  'SENT',
                  'COMPLETED',
                ].includes(data.item.status)
              "
              :to="{
                name: 'email-view-campaign',
                params: { id: data.item.id },
              }"
            >
              <feather-icon icon="EyeIcon" class="mr-50" />
              <span>View</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="['DRAFT'].includes(data.item.status)"
              @click="prepareEditLead(data.item)"
              :to="{
                name: 'email-edit-campaign',
                params: { id: data.item.id },
              }"
            >
              <feather-icon icon="EditIcon" class="mr-50" />
              <span>Edit</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="['DRAFT'].includes(data.item.status)"
              @click="deleteCampaign(data.item.id)"
            >
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span>Delete</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="['DRAFT'].includes(data.item.status)"
              @click="sendFeedback(data.item.id)"
            >
              <feather-icon icon="UserIcon" class="mr-50" />
              <span>Send</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="['SCHEDULED'].includes(data.item.status)"
              @click="cancelCampaign(data.item.id)"
            >
              <feather-icon icon="XIcon" class="mr-50" />
              <span>Cancel</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div class="d-flex justify-content-center mb-1">
        <b-spinner
          variant="success"
          label="Spinning"
          block
          v-if="loading"
          style="width: 3rem; height: 3rem"
        ></b-spinner>
      </div>
      <b-col cols="12" v-if="!loading">
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="center"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-col>
  </b-row>
</div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BAlert,
  BCol,
  BFormGroup,
  BFormSelect,
  BTab,
  BTabs,
  BContainer,
  BPagination,
  BInputGroup,
  BFormInput,
  BForm,
  BFormDatepicker,
  BInputGroupAppend,
  VBModal,
  BButton,
  BSpinner,
  BModal,
  BDropdown,
  BFormTextarea,
  BDropdownItem,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@/@core/utils/validations/validations";
export default {
  components: {
    BTable,
    BAvatar,
    BForm,
    BTab,
    BTabs,
    BModal,
    BBadge,
    BRow,
    BContainer,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    VBModal,
    BFormInput,
    BFormDatepicker,
    BFormTextarea,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BAlert,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    required,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      formState: {},
      selectedCampaignId: "",
      id: this.$route.params.id,
      selectedStatus: null,
      changingcomplaint: null,
      showModal: false,
      currentTab: "All",
      searchQuery: "",
      pageOptions: [3, 5, 10],
      perPage: 5,
      fields: [
        // { key: "ID", label: "Campaign id", sortable: true },
        { key: "name", label: "Campaign Name", sortable: true },
        { key: "createdName", label: "Created By", sortable: true },
        { key: "createdOn", label: "Created On", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "actions" },
      ],
      currentPage: 1,
      perPage: 5,
      campaigns: [],
      form: {
        name: "",
        criteria: null,
        isActive: true,
      },

      editForm: {
        name: "",
        criteria: null,
        isActive: true,
      },
      sources: ["Facebook", "Instagram", "LinkedIn", "Others"],
      sortBy: "",
      sortDesc: false,
      optionsCustomer: [],
      submitting: false,
      campaignNames: [],
      statuses: [
        { value: "DRAFT", text: "DRAFT" },
        { value: "SCHEDULED", text: "SCHEDULED" },
        { value: "COMPLETED", text: "COMPLETED" },
        { value: "CANCELLED", text: "CANCELLED" },
      ],
      selectedCampaignName: "All",
      selectedStatus: "All",
      tableItems: [],
    };
  },
  computed: {
    rows() {
      return this.filteredLeads.length;
    },
    campaignOptions() {
      return [{ value: "", text: "All Campaigns" }].concat(
        this.marketingcampaign.map((campaign) => ({
          value: campaign.id,
          text: campaign.name,
        }))
      );
    },
    ...mapGetters("emailcampaign", {
      emailcampaign: "emailcampaign",
      loading: "loading",
    }),

    filteredLeads() {
    return this.emailcampaign.filter((lead) => {
      const matchesSearchQuery =
        !this.searchQuery ||
        String(lead.name).toLowerCase().includes(this.searchQuery.toLowerCase());
      const matchesCampaignName =
        this.selectedCampaignName === "All" || lead.id === this.selectedCampaignName;
      const matchesStatus =
        this.selectedStatus === "All" || lead.status === this.selectedStatus;
      return matchesSearchQuery && matchesCampaignName && matchesStatus;
    });
  },
  },

  watch: {
    searchQuery() {
      this.filterTable();
    },
  },

  methods: {
    ...mapActions("marketingleadsModule", [
      "getMarketingLeadAction",
      "postMarketingLeadAction",
      "putMarketingLeadAction",
    ]),
    ...mapActions("campaignModule", ["getMarketingCampaignAction"]),
    ...mapActions("segmentModule", [
      "getSegmentsAction",
      "removeSegmentAction",
      "addSegmentAction",
      "updateSegmentAction",
    ]),
    ...mapActions("emailcampaign", [
      "getEmailCampaignListAction",
      "removeEmailCampaignAction",
      "updateEmailCampaignStatusAction",
    ]),

    formatDate(date) {
    if (!date) return '';
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(date).toLocaleDateString(undefined, options);
  },

    getStatusVariant(status) {
      switch (status) {
        case "DRAFT":
          return "secondary";
        case "SCHEDULED":
          return "info";
        case "COMPLETED":
          return "success";
        case "Delivered":
          return "success";
        case "Opened":
          return "primary";
        case "Clicked":
          return "info";
        case "CANCELLED":
          return "danger";
        default:
          return "secondary";
      }
    },

    resetForm() {
      this.form = {
        campaignId: "",
        firstName: "",
        lastName: "",
        email: "",
        source: "",
        status: "New",
        isActive: true,
      };
    },
    // Helper methods
    success(message) {
      this.$swal({
        title: "Success!",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: msg || " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },

    beautifyStatus(status) {
      return status
        .split(/(?=[A-Z])/)
        .join(" ")
        .trim();
    },

    prepareEditLead(item) {
      // Handle edit lead
    },

    async sendFeedback(id) {
      // Handle sending campaign
      const result = await this.$swal({
        title: "Are you sure?",
        text: "You want to complete this Campaign!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes!",
        cancelButtonText: "No, keep it",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      });

      if (result.isConfirmed) {
        this.$swal({
          title: "Cancelling...",
          text: "Please wait while the Campaign is being completed...",
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });

        try {
          console.log("id", id);
          await this.updateEmailCampaignStatusAction({
            id,
            status: "COMPLETED",
          });
          this.$swal.close();
          this.success("Campaign completed successfully!");
        } catch (error) {
          this.$swal.close();
          error;
          this.error(error.response.data);
        } finally {
          await this.getEmailCampaignListAction();
        }
      }
    },
    async cancelCampaign(id) {
      const result = await this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this Campaign!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, cancel it!",
        cancelButtonText: "No, keep it",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      });

      if (result.isConfirmed) {
        this.$swal({
          title: "Cancelling...",
          text: "Please wait while the Campaign is being cancelled...",
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });

        try {
          console.log("id", id);
          await this.updateEmailCampaignStatusAction({
            id,
            status: "CANCELLED",
          });
          this.$swal.close();
          this.success("Campaign cancelled successfully!");
        } catch (error) {
          this.$swal.close();
          error;
          this.error(error.response.data);
        } finally {
          await this.getEmailCampaignListAction();
        }
      }
    },

    async deleteCampaign(id) {
      const result = await this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this Campaign!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      });

      if (result.isConfirmed) {
        this.$swal({
          title: "Deleting...",
          text: "Please wait while the Campaign is being deleted...",
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });

        try {
          await this.removeEmailCampaignAction(id);
          this.$swal.close();
          this.success("Campaign deleted successfully!");
        } catch (error) {
          this.$swal.close();
          this.error(
            "There was a problem deleting the Campaign. Please try again."
          );
        } finally {
          await this.getEmailCampaignListAction();
        }
      }
    },

    promptChangeStatus(complaint) {
      this.changingcomplaint = complaint;
      this.selectedStatus = complaint.status;
      this.$bvModal.show("change-status-modal");
    },
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        //text: msg ?? ' Failed!',
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },
    clearFilters() {
      this.selectedCampaignName = "All";
      this.selectedStatus = "All";
      this.searchQuery = "";
      this.tableItems = this.filteredLeads;
    },
    async fetchDropdownData() {
      await this.getEmailCampaignListAction().then(() => {
        this.campaigns = this.emailcampaign.map((campaign) => ({
          value: campaign.id,
          text: campaign.name,
        }));
      });
    },
    filterTable() {
  let filtered = this.emailcampaign;

  // Filter by campaign name
  if (this.selectedCampaignName && this.selectedCampaignName !== "All") {
    filtered = filtered.filter((campaign) => {
      return campaign.id === this.selectedCampaignName;
    });
  }

  // Filter by status
  if (this.selectedStatus && this.selectedStatus !== "All") {
    filtered = filtered.filter((campaign) => {
      return campaign.status === this.selectedStatus;
    });
  }

  // Filter by search query
  if (this.searchQuery) {
    const query = this.searchQuery.toLowerCase();
    filtered = filtered.filter((campaign) => 
      (campaign.name && campaign.name.toLowerCase().includes(query)) ||
      (campaign.createdName && campaign.createdName.toLowerCase().includes(query)) ||
      (campaign.createdOn && campaign.createdOn.toLowerCase().includes(query)) ||
      (campaign.status && campaign.status.toLowerCase().includes(query)) ||
      (campaign.id && campaign.id.toLowerCase().includes(query))
    );
  }

  this.tableItems = filtered;
  this.totalRows = this.tableItems.length;
  this.currentPage = 1;
},



  },

  async mounted() {
    await this.getEmailCampaignListAction();
    await this.fetchDropdownData();
    this.tableItems = this.filteredLeads;
  },
};
</script>
